import { AccessorsMutatorsDecorator, isInstanceOf } from "../../helpers";
import { TranslatableModel } from "./translatable-model";
import { PropertyType } from "./property-type.model";
import { Property } from "./property.model";

/**
 * @class PropertyClass
 * @property {number} id
 * @property {string} title
 * @property {PropertyType} type
 * @property {string} status
 */
export class PropertyClass extends TranslatableModel {

    /**
     * @type {string[]}
     */
    static get translatableAttributes() {

        return [ 'title' ];
    }

    /**
     * @param {Object|PropertyType} value
     * @returns {PropertyType}
     */
    setType(value) {

        if (typeof value === 'undefined') {

            return value;
        }

        return value instanceof PropertyType ? value : new PropertyType(value);
    }
    
    setProperties(value) {
        
        if (!Array.isArray(value) || !isInstanceOf(Property, value[0])) {
            
            value = Property.factory(value);
        }
        
        return value;
    }

    static get validationModel() {

        return {
            title: {
                label: 'CLASS_NAME_IN_ENGLISH',
                commonLabel: 'Class name'
            },
            title_ar: {
                label: 'CLASS_NAME_IN_ARABIC',
                commonLabel: 'Class name'
            },
            type: {
                label: 'PROPERTY_TYPE',
            }
        };
    }
}

AccessorsMutatorsDecorator('id', ...PropertyClass.translatableAttributesWithLanguageAliases, 'type', 'status', 'properties')(PropertyClass);


// WEBPACK FOOTER //
// ./src/pms-api/models/property-class.model.js